import { render, staticRenderFns } from "./peopleAddSample.vue?vue&type=template&id=64911eab&scoped=true"
import script from "./peopleAddSample.vue?vue&type=script&lang=js"
export * from "./peopleAddSample.vue?vue&type=script&lang=js"
import style0 from "./peopleAddSample.vue?vue&type=style&index=0&id=64911eab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64911eab",
  null
  
)

export default component.exports